export default "__VITE_ASSET__L932qYjb__"